import React from 'react';
import { useTranslation } from 'react-i18next';
import { type IMerchant } from '../../models/IMerchant';
import styles from './index.module.css';
import InstagramIcon from '../../assets/social_icons/Instagram.svg';
import FacebookIcon from '../../assets/social_icons/Facebook.svg';
import TelegramIcon from '../../assets/social_icons/Telegram.svg';
import WhatsAppIcon from '../../assets/social_icons/WhatsApp.svg';

interface IProps {
	merchant: IMerchant;
}

export const MerchantInfoPanel = ({merchant}: IProps) => {
	const { t } = useTranslation('translation');
	function hasSocials () {
		const { instagram, facebook, telegram, whatsapp } = merchant.socials;

		return instagram || facebook || telegram || whatsapp;
	}

	function renderSocials () {
		return hasSocials() ? (
			<div className={`${styles.contacts_row} ${styles.socials_row}`}>
				<span className="text_grey_light">{t('Мы в социальных сетях')}</span>
				<div>
					{merchant.socials.instagram && (
						<a href={merchant.socials.instagram} target="blank" className={styles.social_link}>
							<img src={InstagramIcon} alt="instagram_icon"/>
						</a>
					)}
					{merchant.socials.facebook && (
						<a href={merchant.socials.facebook} target="blank" className={styles.social_link}>
							<img src={FacebookIcon} alt="facebook_icon" className={styles.social_logo}/>
						</a>
					)}
					{merchant.socials.telegram && (
						<a href={merchant.socials.telegram} target="blank" className={styles.social_link}>
							<img src={TelegramIcon} alt="telegram_icon" className={styles.social_logo}/>
						</a>
					)}
					{merchant.socials.whatsapp && (
						<a href={merchant.socials.whatsapp} target="blank" className={styles.social_link}>
							<img src={WhatsAppIcon} alt="whatsapp_icon" className={styles.social_logo}/>
						</a>
					)}
				</div>
			</div>
		) : null;
	}

	return (
		<div className="info_panel">
			<div className={styles.header}>
				<img src={merchant.logo_url} alt="logo" className={styles.logo}/>
				<h6 className={styles.name}>{merchant.name}</h6>
			</div>
			<div className={styles.spoiler}>
				<div className={styles.description}>
					<span className="text_grey_light">{t('О нас')}</span>
					<p className={`${styles.text} ${styles.description_text}`}>{merchant.description}</p>
				</div>
				<div>
					<div className={styles.contacts_row}>
						<span className="text_grey_light">{t('Наш адрес')}</span>
						<p className={styles.text}>{merchant.address}</p>
					</div>
					<div className={styles.contacts_row}>
						<span className="text_grey_light">{t('Контактный телефон')}</span>
						<p className={styles.text}>{merchant.phone}</p>
					</div>
					<div className={styles.contacts_row}>
						<span className="text_grey_light">{t('Контактный email')}</span>
						<p className={styles.text}>{merchant.email}</p>
					</div>
					{renderSocials()}
					{merchant.site_url ? (
						<div className={styles.contacts_row}>
							<a href={merchant.site_url} target="blank" className={styles.site_link}>{t('Перейти на сайт магазина')}</a>
						</div>
					) : null}
				</div>
			</div>
		</div>
	);
};
